import Layout from '../../views/Layout'

const financeRoutes = {
    path: '/finance',
    component: Layout,
    name: 'Finance',
    meta: {
        title: '财务管理',
        icon: 'Money'
    },
    children: [
        // ... 其他财务相关路由
        {
            path: 'cost/utilities_expense',
            name: '水电费管理',
            component: () => import('@/views/Finance/cost/utilities_expense/index.vue'),
            meta: {
                title: '水电费管理',
                keepAlive: true
            }
        },
        {
            path: 'cost/utilities_expense/detail/:account_number',
            name: '水电费明细',
            component: () => import('@/views/Finance/cost/utilities_expense/detail.vue'),
            meta: {
                title: '水电费明细',
                hidden: true,
                keepAlive: false
            }
        }
    ]
}

export default financeRoutes 